import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-aurora-text',
  standalone: true,
  imports: [],
  templateUrl: './aurora-text.component.html',
  styleUrl: './aurora-text.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuroraTextComponent {
  @Input() componentClass = '';
}
